import { Dispatch, SetStateAction, CSSProperties, ReactNode } from 'react';
import { FocusEvent } from 'react';
import { NetworkConnection } from '../common';
import { NumberPad } from './NumberPad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons';


type TypeDialPadProps = {
  setDialedInput: Dispatch<SetStateAction<string>>;
  dialedInputStyle: CSSProperties;
  dialedInput: string;
  handleDisconnect: Function;
  prefixLabel?: string;
  maxLength?: number;
  allowSpecialChars?: boolean;
  leftAddon?: ReactNode;
};

export function DialPad({
  setDialedInput,
  dialedInputStyle,
  dialedInput,
  handleDisconnect,
  prefixLabel,
  maxLength,
  allowSpecialChars = true,
  leftAddon,
}: TypeDialPadProps) {
  const sanitizeInput = (value: string) => {
    const pattern = allowSpecialChars ? /[^\d*#]/g : /\D/g;
    const sanitized = value.replace(pattern, '');
    return typeof maxLength === 'number'
      ? sanitized.slice(0, maxLength)
      : sanitized;
  };

  const updateDialedInput: Dispatch<SetStateAction<string>> = (value) => {
    if (typeof value === 'function') {
      setDialedInput((previous) => sanitizeInput(value(previous)));
      return;
    }

    setDialedInput(sanitizeInput(value));
  };

  const sharedInputStyle: CSSProperties = {
    color: 'inherit',
    fontSize: '0.9rem',
    backgroundColor: 'transparent',
    border: '0',
    borderRadius: '0',
    height: '100%',
    outline: 'none',
    boxShadow: 'none',
  };

  return (
    <>
      <NetworkConnection hangupHandler={handleDisconnect} />
      <div className="d-flex flex-row" style={{marginRight: "-56px"}}>
        {leftAddon}
        <div className="dialer-output shadow-sm" style={dialedInputStyle}>
          <div
            className="d-flex align-items-center border form-control p-0">
            {prefixLabel && (
              <input
                type="text"
                readOnly
                tabIndex={-1}
                value={prefixLabel}
                className="border-0 pl-2 mr-1 form-control"
                style={{
                  ...sharedInputStyle,
                  whiteSpace: 'nowrap',
                  width: '5.5ch',
                  color: 'rgba(120, 120, 120, 0.95)',
                  backgroundColor: "rgba(128, 128, 128, 0.18)",
                  borderRadius: "5px",
                  pointerEvents: 'none',
                  paddingRight: "0px",
                }}
              />
            )}
            <input
              className="border-0 form-control text-left"
              value={dialedInput}
              onChange={(e) => {
                updateDialedInput(e.target.value);
              }}
              onFocus={(e: FocusEvent<HTMLInputElement>) => {
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.outline = 'none';
              }}
              maxLength={maxLength}
              style={{
                ...sharedInputStyle,
                width: "152px",
                paddingLeft: prefixLabel ? '0.1rem' : undefined,
              }}
            />
          </div>
        </div>
        <button
          type="button"
          className="btn dial-backspace shadow-sm ripple"
          onClick={() => {
            updateDialedInput(prev => prev.slice(0, -1))
          }}
          style={{ height: '34px' }}
        >
          <FontAwesomeIcon
            icon={faDeleteLeft}
            className="mr-1 ml-1"
          />
        </button>
      </div>
      <NumberPad setDialedInput={updateDialedInput} />
    </>
  );
}
